<template>
	<v-form ref="form" lazy-validation>
		<modal
			:exibir="exibir"
			:titulo="tituloModal"
			:max-width="modalOptions.largura"
			@close="fecharModal"
			:custom-actions="false"
			:acao-cancelar="fecharModal"
			nome-botao-cancelar="FECHAR"
		>
			<template #body>
				<v-row class="mt-1 mb-2">
					<v-col cols="12">
						<span> {{ descricao }} </span>
					</v-col>
				</v-row>
			</template>
		</modal>
	</v-form>
</template>

<script>
import Modal from '@/views/components/Modal.vue'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'

export default {
	name: 'modal-descricao-ocorrencia',
	components: { Modal },
	mixins: [validacaoFormulario],
	props: {
		exibir: {
			type: Boolean,
		},
		tituloModal: {
			type: String,
			required: true,
		},
		descricao: {
			type: String,
			required: true,
		},
	},
	emits: ['fechar-modal'],
	data() {
		return {
			modalOptions: {
				largura: '1076',
				altura: '1600',
			},
		}
	},
	methods: {
		fecharModal() {
			this.$emit('fechar-modal')
		},
	},
}
</script>

<style lang="stylus" scoped>
.v-dialog
	.texto-titulo
		color #404040
		width 98%
		text-align center
		margin-left 18px
		margin-right 17px
		font-weight 700
		font-size 22px
		line-height 26px

	.close-modal-mobile
		position absolute !important
		right 20px !important

	.mensagem-modal
		display grid !important

	.v-card__title
		word-break break-word

	.texto-corpo
		color #4B4B4B
		font-size 18px
		font-weight 400
		text-align center
		font-style normal
		line-height 25px

	.texto-confirmacao
		color #726f6f
		font-size 18px
		font-weight 400
		text-align center
		font-style normal
		line-height 25px
</style>
